import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  React.useEffect(() => {
    if (open) { setOldPw(""); setNewPw(""); setConfirm(""); }
  }, [open]);

  const save = async () => {
    if (newPw.length < 6) { toast.error("Neues Passwort: mind. 6 Zeichen"); return; }
    if (newPw !== confirm) { toast.error("Passwörter stimmen nicht überein"); return; }
    if (newPw === oldPw) { toast.error("Neues Passwort entspricht dem alten"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Passwort geändert");
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Änderung fehlgeschlagen");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-950 border-zinc-800 text-zinc-100" data-testid="cp-dialog">
        <DialogHeader>
          <DialogTitle>Passwort ändern</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div>
            <Label className="text-xs text-zinc-400">Aktuelles Passwort</Label>
            <Input type="password" value={oldPw} onChange={(e) => setOldPw(e.target.value)}
              className="bg-zinc-900 border-zinc-800 text-zinc-100 mt-1 h-10 rounded-md"
              data-testid="cp-old" autoFocus />
          </div>
          <div>
            <Label className="text-xs text-zinc-400">Neues Passwort</Label>
            <Input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)}
              placeholder="Mind. 6 Zeichen"
              className="bg-zinc-900 border-zinc-800 text-zinc-100 mt-1 h-10 rounded-md"
              data-testid="cp-new" />
          </div>
          <div>
            <Label className="text-xs text-zinc-400">Wiederholen</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="bg-zinc-900 border-zinc-800 text-zinc-100 mt-1 h-10 rounded-md"
              data-testid="cp-confirm" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}
            className="bg-transparent border-zinc-700 text-zinc-300 hover:bg-zinc-900 rounded-md">
            Abbrechen
          </Button>
          <Button onClick={save} disabled={saving}
            className="bg-brand hover:bg-brand-light text-white rounded-md" data-testid="cp-save">
            {saving ? "Speichern…" : "Ändern"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
